/**
 *
 * Copyright (c) 2020, Vathos GmbH
 *
 * All rights reserved.
 */
import axios from 'axios';

import urlHelpers from '@/helpers/url.helpers';

const appUrl = process.env.VUE_APP_API_URL;
const apiFactory = (endpoint)=> {
  const api = {};
  api.search = async (query, headers = {}) => {
    let url = `${appUrl}/${endpoint}`;
    url += `?${urlHelpers.encodeQueryData(query)}`;
    return await axios.get(url, {headers});
  };
  api.load = async (id, query, headers = {}) => {
    let url = `${appUrl}/${endpoint}/${id}`;
    if (query) {
      url += `?${urlHelpers.encodeQueryData(query)}`;
    }
    return await axios.get(url, {headers});
  };
  api.create = async (data, headers = {}) => {
    const url = `${appUrl}/${endpoint}`;
    return await axios.post(url, data, {headers});
  };
  api.update = async (id, data, headers = {}) => {
    const url = `${appUrl}/${endpoint}/${id}`;
    return await axios.patch(url, data, {headers});
  };
  api.remove = async (id, headers = {}) => {
    const url = `${appUrl}/${endpoint}/${id}`;
    return await axios.delete(url, {headers});
  };
  return api;
};
export default apiFactory;
